const handleInitSwiper = ({ id, isEnabled, viewType }) => {
  const pageWidth = document?.body?.offsetWidth;
  const isDesktop = pageWidth > DESKTOP_WIDTH;
  const isEnabledAsBool = isEnabled === 'true';
  const isSwiperEnable = isDesktop ? isEnabledAsBool : true;
  const paginationId = `swiper-pagination-${id}`;
  const isViewDesktop = viewType === 'desktop';
  const paginationEnabled = {
    pagination: {
      el: `#${paginationId}`,
      type: 'bullets',
    },
  };

  const navigationEnabled = {
    navigation: {
      nextEl: `#swiper-button-next-${id}`,
      prevEl: `#swiper-button-prev-${id}`,
    },
  };

  if (!isSwiperEnable) {
    const navigationWrapper = document.getElementById(
      `swiper-navigation-wrapper-${id}`
    );

    navigationWrapper?.classList?.add('!hidden');
  }

  const swiper = new Swiper(`#category-slider-${id}`, {
    speed: DEFAULT_SLIDER_SPEED,
    spaceBetween: isViewDesktop ? 16 : 4,
    loop: false,
    slidesPerView: isViewDesktop ? 6 : 1.5,
    centeredSlides: false,
    centeredSlidesBounds: false,
    slidesOffsetBefore: isViewDesktop ? 0 : 16,
    slidesOffsetAfter: isViewDesktop ? 0 : 16,
    init: isSwiperEnable,
    observer: true,
    observeParents: true,
    ...navigationEnabled,
    ...paginationEnabled,
    updateOnWindowResize: true,
    on: {
      init: function () {
        this?.el?.classList.remove('opacity-0');
        this?.wrapperEl?.classList.remove(
          'items-center',
          'justify-center',
          'gap-4'
        );
      },
    },
    watchOverflow: true,
  });

  return swiper;
};

const handleInitCategorySlider = () => {
  const categorySliders = document?.querySelectorAll(
    '.js-category-slider-swiper'
  );

  if (categorySliders?.length === 0) {
    return null;
  }

  categorySliders.forEach((element) =>
    handleInitSwiper({
      id: element?.dataset?.id,
      isEnabled: element?.dataset?.swiperEnable,
      viewType: element?.dataset?.viewType,
    })
  );
};

handlePageLoadEvent(handleInitCategorySlider);
handleShopifyEditorEvent(handleInitCategorySlider);
